import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
const HomeEssentials = () => {
  const navigate = useNavigate();
  const homeItems = [{
    name: 'Refrigerator (Double Door)',
    price: '₦450,000'
  }, {
    name: 'Washing Machine (Automatic)',
    price: '₦280,000'
  }, {
    name: 'Microwave Oven',
    price: '₦85,000'
  }, {
    name: 'Gas Cooker (4 Burner)',
    price: '₦120,000'
  }, {
    name: 'Blender Set',
    price: '₦45,000'
  }, {
    name: 'Dining Table Set (6 Seater)',
    price: '₦180,000'
  }, {
    name: 'Sofa Set (7 Seater)',
    price: '₦350,000'
  }, {
    name: 'Bed Frame (King Size)',
    price: '₦220,000'
  }, {
    name: 'Mattress (King Size)',
    price: '₦180,000'
  }, {
    name: 'Wardrobe (Wooden)',
    price: '₦250,000'
  }, {
    name: 'TV Stand',
    price: '₦75,000'
  }, {
    name: 'Center Table',
    price: '₦65,000'
  }, {
    name: 'Bedding Set (Premium)',
    price: '₦55,000'
  }, {
    name: 'Curtains (Full Set)',
    price: '₦80,000'
  }, {
    name: 'Kitchen Cabinet Set',
    price: '₦320,000'
  }, {
    name: 'Pots and Pans Set',
    price: '₦45,000'
  }, {
    name: 'Cutlery Set (Complete)',
    price: '₦35,000'
  }, {
    name: 'Dinner Set (12 Piece)',
    price: '₦40,000'
  }, {
    name: 'Electric Kettle',
    price: '₦18,000'
  }, {
    name: 'Rice Cooker',
    price: '₦32,000'
  }, {
    name: 'Iron and Ironing Board',
    price: '₦25,000'
  }, {
    name: 'Vacuum Cleaner',
    price: '₦55,000'
  }, {
    name: 'Standing Fan Set',
    price: '₦45,000'
  }, {
    name: 'Wall Clock',
    price: '₦12,000'
  }, {
    name: 'Bathroom Accessories Set',
    price: '₦28,000'
  }, {
    name: 'Towel Set (Premium)',
    price: '₦22,000'
  }, {
    name: 'Rug Set',
    price: '₦48,000'
  }, {
    name: 'Mirror (Decorative)',
    price: '₦35,000'
  }, {
    name: 'Lamp Set',
    price: '₦30,000'
  }, {
    name: 'Storage Boxes Set',
    price: '₦20,000'
  }];
  return <div className="min-h-screen bg-ivory" data-id="element-209">
      <div className="section-container" data-id="element-210">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-700 hover:text-gold mb-8 transition-colors" data-id="element-211">
          <ArrowLeft size={20} className="mr-2" data-id="element-212" />
          Back to Home
        </button>

        <h1 className="section-heading" data-id="element-213">Home Essentials Gift Registry</h1>
        <p className="text-center text-gray-700 max-w-2xl mx-auto mb-12" data-id="element-214">
          Help us build our new home together. Select an item you'd like to gift
          us, and we'll provide payment details on the next page.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-215">
          {homeItems.map((item, index) => <div key={index} className="bg-white border border-champagne border-opacity-40 p-6 rounded-md shadow-sm" data-id="element-216">
              <h3 className="font-serif text-lg text-gray-800 mb-2" data-id="element-217">
                {item.name}
              </h3>
              <p className="text-gold font-semibold text-xl mb-4" data-id="element-218">
                {item.price}
              </p>
              <button onClick={() => navigate('/gifts/payment', {
            state: {
              item: item.name,
              price: item.price,
              type: 'Home Essential'
            }
          })} className="w-full px-4 py-2 bg-gold text-white hover:bg-opacity-90 transition-colors duration-300" data-id="element-219">
                Select This Gift
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default HomeEssentials;